'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _is = require('./is');

var _is2 = _interopRequireDefault(_is);

var _astLocUtils = require('ast-loc-utils');

var _babelTypesPatch = require('./util/babelTypesPatch');

var _babelTypesPatch2 = _interopRequireDefault(_babelTypesPatch);

var _lscNodeTypes = require('./lscNodeTypes');

var _functions = require('./functions');

var _blocks = require('./blocks');

var _variables = require('./variables');

var _classes = require('./classes');

var _match = require('./match');

var matching = _interopRequireWildcard(_match);

var _comprehension = require('./comprehension');

var comprehension = _interopRequireWildcard(_comprehension);

var _safe = require('./safe');

var _inlinedOperators = require('./inlinedOperators');

var _for = require('./for');

var _helpers = require('./helpers');

var _stdlib = require('./stdlib');

var _config = require('./config');

var _compilerState = require('./compilerState');

var _fixAst = require('./fixAst');

var _placeholders = require('./placeholders');

var _pipe = require('./pipe');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function Lightscript(babel) {
  var t = babel.types;

  (0, _babelTypesPatch2.default)(t);
  (0, _lscNodeTypes.registerLightscriptNodeTypes)(t);

  // traverse as top-level item so as to run before other babel plugins
  // (and avoid traversing any of their output)
  function Program(path, state) {
    var opts = state.opts;
    var compilerState = (0, _compilerState.createCompilerState)({
      programPath: path,
      babel,
      opts,
      file: state.file
    });

    if (!compilerState.isLightScript) return;

    (0, _compilerState.initializeCompilerState)();

    // TODO: helpers -> compilerState
    (0, _helpers.resetHelpers)(path);

    //// AST transforms
    // Perform basic ast fixups (block bodies, etc)
    (0, _fixAst.fixAst)(path);

    // Transform placeholder expressions first.
    if (compilerState.opts.placeholderArgs) {
      (0, _placeholders.transformPlaceholders)(path);
    } // Main LSC transforms
    path.traverse({
      PipeCallExpression(path) {
        (0, _pipe.transformPipeOperator)(path);
      }, ForInArrayStatement(path) {
        // TODO: push the linter conditional down into the transform
        // and get linter status from compilerState
        if (opts.__linter) {
          (0, _for.lintForInArrayStatement)(path);
        } else {
          (0, _for.transformForInArrayStatement)(path);
        }
      }, ForInObjectStatement(path) {
        // TODO: push the linter conditional down into the transform
        // and get linter status from compilerState
        if (opts.__linter) {
          (0, _for.lintForInObjectStatement)(path);
        } else {
          (0, _for.transformForInObjectStatement)(path);
        }
      }, ArrayComprehension(path) {
        if (opts.enhancedComprehension) {
          comprehension.transformArrayComprehension(path);
        } else {
          comprehension.transformPlainArrayComprehension(path);
        }
      }, ObjectComprehension(path) {
        if (opts.enhancedComprehension) {
          comprehension.transformObjectComprehension(path);
        } else {
          comprehension.transformPlainObjectComprehension(path);
        }
      }, TildeCallExpression: {
        // run on exit instead of enter so that SafeMemberExpression
        // can process differently from a wrapping CallExpression
        // eg; `a?.b~c()` -> `a == null ? null : c(a.b)`
        exit(path) {
          var node = path.node;

          var args = [node.left].concat(_toConsumableArray(node.arguments));
          var callExpr = (0, _astLocUtils.placeAtNode)(t.callExpression(node.right, args), node);

          if ((0, _inlinedOperators.replaceWithInlinedOperator)(path, node.right, args)) return;

          if (node.safe) {
            (0, _safe.replaceWithSafeCall)(path, callExpr);
          } else {
            path.replaceWith(callExpr);
          }
        } },

      CallExpression: {
        exit(path) {
          var node = path.node;

          if ((0, _inlinedOperators.replaceWithInlinedOperator)(path, node.callee, node.arguments)) return;
          if (node.safe) (0, _safe.replaceWithSafeCall)(path, node);
        } },

      NamedArrowFunction(path) {
        if (path.node.skinny) {
          (0, _functions.replaceWithPlainFunction)(path);
        } else if (path.node.generator) {
          // there are no arrow-generators in ES6, so can't compile to arrow
          (0, _functions.replaceWithBoundFunction)(path);
        } else {
          (0, _functions.replaceWithArrowFunction)(path);
        }
      }, NamedArrowMemberExpression(path) {
        var object = path.node.object;
        var node = path.node;
        delete node.object;
        node.type = "NamedArrowExpression";

        if (!node.skinny) {
          node.skinny = true; // binding here, don't turn into arrow
          node = (0, _astLocUtils.placeTreeAtLocWhenUnplaced)(t.callExpression(t.memberExpression(node, t.identifier("bind")), [object]), (0, _astLocUtils.getLoc)(object));
        }

        path.replaceWith((0, _astLocUtils.placeAtNode)(t.assignmentExpression("=", (0, _astLocUtils.placeAtLoc)(t.memberExpression(object, path.node.id), (0, _astLocUtils.getSurroundingLoc)([object, path.node.id])), node), node));
      }, ArrowFunctionExpression(path) {
        if (path.node.skinny) {
          (0, _functions.replaceWithPlainFunction)(path);
        } else if (path.node.generator) {
          (0, _functions.replaceWithBoundFunction)(path);
        }
      }, ClassBody(path) {
        var fatArrows = [],
            fatStaticArrows = [],
            constructorPath = void 0;
        path.node.body.forEach(function (method, i) {
          if (!t.isMethod(method)) return;

          if (method.kind === "constructor") {
            return constructorPath = path.get(`body.${i}.body`);
          } else if (method.static && method.skinny === false) {
            fatStaticArrows.push(method.key);
            return method.skinny = true; // prevent infinite recursion
          } else if (method.skinny === false) {
            fatArrows.push(method.key);
            return method.skinny = true; // prevent infinite recursion
          }
        });

        var maybeAddSuper = path.parentPath.node.superClass && constructorPath;
        if (fatArrows.length || maybeAddSuper) {
          constructorPath = (0, _classes.ensureConstructor)(path.parentPath, constructorPath, true);
        }

        if (fatArrows.length) {
          (0, _classes.bindMethodsInConstructor)(path.parentPath, constructorPath, fatArrows);
        }

        if (fatStaticArrows.length) {
          (0, _classes.bindMethods)(path.parentPath, fatStaticArrows);
        }
      }, ObjectExpression(path) {
        var fatArrowKeys = function () {
          var _arr = [];
          for (var _arr3 = path.node.properties, _i2 = 0, _len2 = _arr3.length; _i2 < _len2; _i2++) {
            var _prop = _arr3[_i2];
            if ((0, _is.isa)(_prop, "Method") && _prop.skinny === false) {
              _prop.skinny = true; // prevent recursion
              _arr.push(_prop.key);
            }
          }return _arr;
        }();

        if (fatArrowKeys.length) (0, _classes.bindMethods)(path, fatArrowKeys);
      }, Function: {
        exit(path) {
          (0, _functions.addImplicitReturns)(path);

          // As this is an exit visitor, other LSC transforms have reduced
          // arrows to plain FunctionDeclarations by this point.
          if (path.node.type === "FunctionDeclaration") {
            // somehow this wasn't being done... may signal deeper issues...
            path.getFunctionParent().scope.registerDeclaration(path);
          }
        } },

      IfExpression(path) {
        // TODO: better source mapping here -- place implicit null at end of consequent?
        var consequent = (0, _blocks.blockToExpression)(path.get("consequent"));

        var alternate = path.node.alternate ? (0, _blocks.blockToExpression)(path.get("alternate")) : (0, _astLocUtils.placeAtNode)(t.nullLiteral(), path.node);

        path.replaceWith((0, _astLocUtils.placeAtNode)(t.conditionalExpression(path.node.test, consequent, alternate), path.node));
      }, AssignmentExpression(path) {
        if (path.node.operator === "<-" || path.node.operator === "<!-") {
          path.node.operator = "=";
        }if ((0, _is2.default)("MemberExpression", path.node.left)) return;

        if (path.node.isNowAssign === false) {
          throw path.buildCodeFrameError("Incorrect assignment: to reassign, use `now`; to assign as `const`, put on its own line.");
        }
      }, SafeAwaitExpression(path) {
        var errId = path.scope.generateUidIdentifier("err");
        var awaitIife = (0, _blocks.iife)((0, _astLocUtils.placeTreeAtLocWhenUnplaced)(t.tryStatement(t.blockStatement([t.returnStatement(t.awaitExpression(path.node.argument))]), t.catchClause(errId, t.blockStatement([t.returnStatement(errId)]))), (0, _astLocUtils.getLoc)(path.node)), true);

        // TODO: returntype annotation
        var awaitExpr = (0, _astLocUtils.placeTreeAtLocWhenUnplaced)(t.awaitExpression(awaitIife), (0, _astLocUtils.getLoc)(path.node));
        path.replaceWith(awaitExpr);
      }, SafeMemberExpression(path) {
        (0, _safe.transformSafeMemberExpression)(path);
      }, AwaitExpression(path) {
        if (path.get("argument").isArrayExpression() || path.node.argument.type === "ArrayComprehension") {
          var promiseDotAllCall = t.callExpression(t.memberExpression(t.identifier("Promise"), t.identifier("all")), [path.node.argument]);
          path.get("argument").replaceWith(promiseDotAllCall);
        }
      }, VariableDeclaration(path) {
        // Error on auto-const when shadowing variable
        if (path.node.kind === "const") {
          if (path.node.extra && path.node.extra.implicit === true) {
            var id = (0, _variables.getShadowingIdentifiers)(path)[0];
            if (id) {
              throw path.buildCodeFrameError(`\`${id.name}\` is shadowed from a higher scope. ` + `If you want to reassign the variable, use \`now ${id.name} = ...\`. ` + "If you want to declare a new shadowed \`const\` variable, " + `you must use \`const ${id.name} = ...\` explicitly.`);
            }
          }
        }
      } // collect functions to be imported for the stdlib
      , ReferencedIdentifier(path) {
        if (!(0, _variables.checkFalsePositiveReference)(path)) {
          (0, _stdlib.markIdentifier)(compilerState.stdlib, path);
        }
      }, ExistentialExpression(path) {
        (0, _safe.transformExistentialExpression)(path);
      }, MatchExpression(path) {
        matching.transformMatchExpression(path, opts.__linter);
      }, MatchStatement(path) {
        matching.transformMatchStatement(path, opts.__linter);
      } });

    (0, _compilerState.postprocess)(compilerState);
  } // Program()

  var visitor = {
    Program
  };

  // TODO: factor out to config.lsc
  function computeParserOpts(file) {
    // By this time, we have access to the code of the file.
    // We can parse shebang, directives, etc and manipulate parser options
    // based on those data.
    file.parseShebang();
    var opts = file.opts,
        parserOpts = file.parserOpts;

    var fileTypeInfo = (0, _compilerState.getFileTypeInfo)(file);
    var pluginOpts = (0, _config.locatePluginOpts)(opts, plugin) || {}; // XXX: see comments below
    var cdOpts = (0, _config.parseConfigurationDirectives)(file.code);

    // Don't read as LSC
    if (!fileTypeInfo.isLightScript && !cdOpts.isLightScript) return;

    file.isLightScript = true;
    Object.assign(pluginOpts, cdOpts);

    // Get LSC parser opts
    opts.parserOpts = opts.parserOpts || {};
    var nextParserOpts = (0, _config.getParserOpts)(pluginOpts, opts.parserOpts);
    parserOpts.parse = nextParserOpts.parse;
    return parserOpts.plugins = nextParserOpts.plugins;
  }var plugin = {
    manipulateOptions(opts, parserOpts, file) {
      // This entire thing is a workaround for what is IMO a babel design flaw.
      // Relevant Babel code:
      // https://github.com/babel/babel/blob/4e50b2d9d9c376cee7a2cbf56553fe5b982ea53c/packages/babel-core/src/transformation/file/index.js#L63
      // https://github.com/babel/babel/blob/4e50b2d9d9c376cee7a2cbf56553fe5b982ea53c/packages/babel-core/src/transformation/file/index.js#L483
      //
      // manipulateOptions is called very early in the Babel processing chain.
      // It doesn't get an opportunity to see the configuration options for the
      // plugin being run (without a workaround above) nor does it get an
      // opportunity to see the code that will be compiled.
      //
      // This rules out things like parsing configuration directives from the
      // top of a JS file to manipulate parsing and compiling options.
      //
      // This monkey patch defers the option manipulation until after the file
      // has been read, but before actual parsing.
      var origAddCode = file.addCode;

      return file.addCode = function addCode(code) {
        origAddCode.call(this, code);
        computeParserOpts(this);
        return;
      };
    }, visitor
  };

  return plugin;
}exports.default = Lightscript;
module.exports = exports['default'];